import type HttpStatusCode from "./HttpStatusCode";

export function isSuccessStatusCode(statusCode: number): boolean {
    return statusCode >= 200 && statusCode < 300;
}
